import React from "react";
import Image from "components/image";
import clsx from "clsx/lite";

const HeaderBar = ({ data }) => {
	const { content, wider } = data;

	return (
		<div className={`${wider ? "py-7.5 md:py-10" : ""}`}>
			<div className="hd-screen-max-width w-full px-4 mx-auto box-border">
				<div
					className="w-full flex justify-center lg:justify-between flex-wrap items-center">
					{content?.map((c) => (
						<div key={c?._key} className={
							clsx(
								"flex flex-col lg:flex-row justify-center lg:w-1/4 items-center my-3 text-xs text-center",
								wider ? "w-1/2" : "w-1/3"
							)
						}>
							{c?.icon && <Image className={`w-10 ${wider ? "md:w-15" : ""}`} image={c.icon.asset} alt={c.icon.alt} />}{" "}
							<span className={clsx(
								"md:ml-2 mt-2",
								wider ? "text-base md:text-base-lg w-1/2 text-center lg:text-left" : "text-xs md:text-base"
							)}>{c.text}</span>
						</div>
					))}
				</div>
			</div>

		</div>
	);
};

export default HeaderBar;
